import React from "react";
import Toast from '@/Toast';
import Modal from "react-modal";
import moment from 'moment';
import Loading from '@/Loading';
const STATUS_LOADING = 0 // 还没有图片
const STATUS_READY = 1 // 图片渲染完成,可以开始滑动
const STATUS_MATCH = 2 // 图片位置匹配成功
const STATUS_ERROR = 3 // 图片位置匹配失败

// 278 * 285
class _FpCaptcha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgSrc: "",
            showInfo: false,
            isMovable: false,
            startX: 0, // 开始滑动的 x
            startY: 0, // 开始滑动的 y
            currX: 0, // 当前的 x
            currY: 0, // 当前的 y
            status: STATUS_LOADING,
            verifyStatus: "0", // (0:未验证，1:验证成功，2:验证失败)
        }
        this.canvas = null;
        this.ctx = null;
        this.img = null;
        this.options = {
            col: 10,
            row: 2,
            chartUri: '',
            shuffleMatrix: [],
        }
        this.allowRefresh = true;
    }

    componentDidUpdate(prevProps) {
        const { chartUri, keyUri, shuffleMatrix, visible } = this.props;
        if (!!chartUri && prevProps.chartUri !== chartUri) {
            this.setState({
                chartUri: chartUri,
                keyUri: keyUri,
                shuffleMatrix: shuffleMatrix,
            }, () => {
                let { chartUri, keyUri, shuffleMatrix } = this.state;
                this.createCanvas()
                this.renderImage({ chartUri, keyUri, shuffleMatrix })
            })
        }
        if (prevProps.visible !== visible && !visible) {
            this.onReset();
        }
    }
    // 创建canvas
    createCanvas = () => {
        this.canvas = document.createElement('canvas')
        this.ctx = this.canvas.getContext('2d')
        this.canvas.width = '300'
        this.canvas.height = '150'
    }
    renderImage = async (options) => {
        this.options = { ...this.options, ...options }
        try {
            var image = new Image();
            image.crossOrigin = '';
            image.src = this.options.chartUri;
            image.onload = (e) => {
                this.img = image;
                this.splitImg();
            }
        } catch (e) {
            console.log(e)
        }
    }
    // 切割图片
    splitImg = () => {
        let list = []
        for (let y = 0; y < this.options.row; y++) {
            for (let x = 0; x < this.options.col; x++) {
                let simpleWidth = parseInt(this.img.width / this.options.col)
                let simpleHeight = parseInt(this.img.height / this.options.row)
                list.push({
                    x: x * simpleWidth,
                    y: y * simpleHeight,
                    width: simpleWidth,
                    height: simpleHeight,
                })
            }
        }
        let sortList = this.sortList(list);
        this.setImgBase64(sortList);
    }
    // 图片排序
    sortList = (list) => {
        list.forEach((element, i) => {
            element.index = this.options.shuffleMatrix[i]
        });
        let newlist = list.sort((param1, param2) => {
            return param1.index - param2.index
        })
        return newlist;
    }
    setImgBase64 = async (list) => {
        try {
            await this.drawImg(list);
            const base64 = this.canvas.toDataURL()
            this.setState({
                imgSrc: base64,
                status: STATUS_READY,
            })
            this.props.setLoading(false)
        } catch (e) {
            console.error('Error in setImgBase64:', e)
            this.props.setLoading(false)
        }
    }
    // 绘制图片
    drawImg = (list) => {
        // 清空画布
        if (this.ctx) {
            this.ctx.clearRect(0, 0, 300, 150)
        }
        for (let k = 0; k < list.length; k++) {
            let object = list[k]
            let dx, dy;
            if (k > 9) {
                dx = (k - 10) * 30;
                dy = 75;
            } else {
                dx = (k - 0) * 30;
                dy = 0;
            }
            if (this.ctx) {
                this.ctx.drawImage(this.img, object.x, object.y, object.width, object.height, dx, dy, object.width, object.height)
            }
        }

    }
    
    // 通用的拖拽處理邏輯
    handleDrag = (clientX, clientY, startTime, moveEventType, endEventType) => {
        let that = this;
        let target = document.getElementById("moveElement");
        
        that.setState({ isMovable: true, startX: clientX, startY: clientY, startTime: startTime },
            () => {
                // 設置移動事件
                document[moveEventType] = function (e) {
                    e.preventDefault();
                    if (that.state.status !== STATUS_READY || !that.state.isMovable) {
                        return
                    }
                    
                    // 獲取當前座標
                    let currentClientX, currentClientY;
                    if (moveEventType === 'onmousemove') {
                        currentClientX = e.clientX;
                        currentClientY = e.clientY;
                    } else if (moveEventType === 'ontouchmove') {
                        let touch = e.touches[0];
                        currentClientX = touch.clientX;
                        currentClientY = touch.clientY;
                    }
                    
                    const distanceX = currentClientX - that.state.startX;
                    const distanceY = currentClientY - that.state.startY;
                    let currX = distanceX;
                    let currY = distanceY;

                    const minX = 0;
                    const minY = 0;
                    const maxX = 300 - 60;
                    const maxY = 150 - 60;

                    currX = currX < minX ? 0 : currX > maxX ? maxX : currX;
                    currY = currY < minY ? 0 : currY > maxY ? maxY : currY;

                    that.setState({ currX, currY },
                        () => {
                            // 設置結束事件
                            target[endEventType] = function () {
                                e.preventDefault();
                                if (that.state.status !== STATUS_READY || !that.state.isMovable) {
                                    return
                                }
                                let { startTime } = that.state;
                                const nowTime = moment();
                                const cost = new Date(nowTime).getTime() - new Date(startTime).getTime();
                                
                                that.setState({
                                    isMovable: false,
                                })
                                
                                // 清理事件監聽器
                                document[moveEventType] = null;
                                target[endEventType] = null;
                                
                                that.props.judgement({ x: that.state.currX, y: that.state.currY, cost: cost }, that.judgeResult);
                            }
                        })
                }
            })
    }

    // 鼠标按下事件
    onMouseDownEvent = (e) => {
        if (this.state.status !== STATUS_READY) {
            return
        }
        const startTime = moment();
        this.handleDrag(e.clientX, e.clientY, startTime, 'onmousemove', 'onmouseup');
    }

    // 觸控開始事件
    onTouchStartEvent = (e) => {
        if (this.state.status !== STATUS_READY) {
            return
        }
        let touch = e.touches[0];
        const startTime = moment();
        this.handleDrag(touch.clientX, touch.clientY, startTime, 'ontouchmove', 'ontouchend');
    }
    judgeResult = (code) => {
        if (['10001', '10002', '11001'].includes(String(code))) {
            this.props.onLogin(this.props.challengeUuid)
            this.setState({ verifyStatus: "1" })
            const timer = setTimeout(() => {
                this.props.setVisible(false)
                this.setState({ verifyStatus: "0" })
                clearTimeout(timer);
            }, 1000);
        } else {
            this.setState({ verifyStatus: "2" })
            
            this.allowRefresh = false;
            const timer = setTimeout(() => {
                this.resetPosition();
                clearTimeout(timer);
            }, 1000);
            if (code == '63403') { // 超过解答上限
                this.props.onReload()
            }
        }
    }
    resetPosition = () => {
        this.setState({
            currX: 0,
            currY: 0,
            status: STATUS_READY,
            verifyStatus: "0"
        })
    }
    onRefresh = () => {
        if (this.allowRefresh == false) {   // 防恶意刷新
            Toast.fail("操作过于频繁，请稍后再试。", 2);
            setTimeout(() => {
                this.allowRefresh = true
            }, 3000)
            return;
        }
        this.allowRefresh = false;
        this.onReset();
        this.props.onReload()
    }
    onReset = () => {
        this.canvas = null;
        this.ctx = null;
        this.img = null;
        // 清理所有事件監聽器
        document.onmousemove = null;
        document.ontouchmove = null;
        const target = document.getElementById("moveElement");
        if (target) {
            target.onmouseup = null;
            target.ontouchend = null;
        }
        this.setState(
            {
                imgSrc: '',
                isMovable: false,
                startX: 0,
                startY: 0,  // 开始滑动的 x
                currX: 0, // 滑块当前 x,
                currY: 0, // 滑块当前 x,
                status: STATUS_LOADING
            }
        )
    }
    onShowInfo = () => {
        this.setState({ showInfo: !this.state.showInfo })
    }
    render() {
        const {
            imgSrc,
            showInfo,
            verifyStatus,
            keyUri,
            currX,
            currY
        } = this.state;
        const { visible, setVisible, loading } = this.props;
        return <Modal
            isOpen={visible}
            overlayClassName="fpcaptch-overlay"
            appElement={typeof document !== 'undefined' ? document.getElementById('__next') : undefined}
        >
            {loading && !imgSrc ? <Loading /> : null}
            <div className='fpcontent'>
                <p>
                    <span>请拖动左边的滑块，来完成拼图</span>
                    <img src="/static/images/captcha/close.svg" width='18px' height='18px' onClick={() => {setVisible(false)}} />
                </p>
                <div className="fpSection" style={{ background: imgSrc ? `url(${imgSrc}) no-repeat` : "#eee" }}>
                    <div
                        className='moveElement'
                        id="moveElement"
                        style={{
                            background: imgSrc && keyUri ? `url(${keyUri}) no-repeat` : "#eee",
                            left: currX + "px",
                            top: currY + "px"
                        }}
                        onMouseDown={(e) => this.onMouseDownEvent(e)}
                        onTouchStart={(e) => this.onTouchStartEvent(e)}
                    >
                    </div>
                    <div className='info' style={{ display: showInfo ? "block" : "none" }}>
                        <img src="/static/images/captcha/icon-closed.png" onClick={this.onShowInfo} />
                        <p>按住拼图滑块不放，并向右拖动，将图中小方块拖到缺口位置进行拼合；拼图完成后松手，即可通过验证。</p>
                    </div>
                    <div className='message-wrap' style={{ display: verifyStatus === "1" ? "block" : "none" }}>
                        <img src="/static/images/captcha/success.png" />
                        <span>验证成功</span>
                    </div>
                    <div className='message-wrap _fail' style={{ display: verifyStatus === "2" ? "block" : "none" }}>
                        <img src="/static/images/captcha/fail.png" />
                        <span>验证失败，请重新尝试。</span>
                    </div>
                </div>
                <div className='fpFooter'>
                    <img src='/static/images/captcha/icon-refresh.svg' onClick={this.onRefresh} />
                    <img src='/static/images/captcha/icon-info.svg' onClick={this.onShowInfo} />
                </div>
            </div>
        </Modal>
    }
}

export default _FpCaptcha;